var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "10px",
    viewBox: "0 0 13 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sprint-7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-listing",
    transform: "translate(-298.000000, -567.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(292.000000, 562.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7718881,10.9655263 C10.2121685,10.4483778 9.30729117,9.50092942 8.70444122,8.89807946 C8.10157692,8.33835988 7.71386249,8.81179575 6.981521,9.5872332 C6.16294743,10.4058068 6.981521,10.8361065 8.14467861,11.9992068 L10.2552989,14.1098271 C11.0307278,14.7989808 11.6767511,13.7652574 12.7104459,12.7746643 L16.9316865,8.51039372 C18.2668492,7.21837568 18.5682599,7.21837568 17.4914061,6.18462355 C16.5439577,5.19404483 16.5871024,5.19404483 15.0794325,6.74434313 C14.3902787,7.39035215 10.9877121,10.8360635 10.7719885,10.9655837 L10.7718881,10.9655263 Z",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCheck);
export default __webpack_public_path__ + "static/media/small-check.dbd1302ab0de785c71a749bed17f9c59.svg";
export { ForwardRef as ReactComponent };